<template>
  <div class="chat-message-player min-w-0 w-full">
    <wui-audio-player
      ref="playerRef"
      :audio-src="src"
      :track-name="fileName"
      is-square
      hide-volume-control
      @playing="onPlaying"
    />
  </div>
</template>

<script setup lang="ts">
import { WuiAudioPlayer } from '@wui/common-library'
import { computed, onUnmounted, ref, watch } from 'vue'

import { useChatMessageIsPlayMap } from '@/shared/components/players'

type WuiAudioPlayerInstance = InstanceType<typeof WuiAudioPlayer> & {
  audioPlayer: HTMLAudioElement | null
}

const props = defineProps<{
  src: string
  fileName: string
  dark: boolean
  type: 'OutgoingMessage' | 'IncomingMessage'
}>()

const { enable, disable, isPlayMap } = useChatMessageIsPlayMap(props.src)
const isPlay = computed(() => Boolean(isPlayMap.value.get(props.src)))
const playerRef = ref<WuiAudioPlayerInstance | null>(null)

const onPlaying = (playing: boolean) => {
  if (playing) {
    enable()
  } else {
    disable()
  }
}

watch(isPlay, (value) => {
  const audio = playerRef.value?.audioPlayer
  if (!audio) return

  if (value && audio.paused) {
    void audio.play()
  } else if (!value && !audio.paused) {
    audio.pause()
  }
})

onUnmounted(() => {
  disable()
})
</script>

<style scoped>
/* TODO: remove this when wui-audio-player will be fixed */
.chat-message-player :deep(.wui-audio-player) {
  --size-ply-min-width: 0;
  --size-ply-content-min-width: 0;
  min-width: 0;
  /* WUI-4413: brand timeline → baseDarkBlue (lib still maps to brand-base) */
  --color-ply-timeline-def: var(--color-surf-brand-basedarkblue-def);
}
</style>
